import { handleApiError } from '@/handleApiError'
import api from '@/modules/address/api'
import { getAddressFieldErrors } from '@/modules/address/helpers'
import { AddressType, CheckoutAddressValidation, ShopAddress } from '@/types/index'
import { defineStore } from 'pinia'

type AddressValidationState = {
  [key in AddressType]: CheckoutAddressValidation
}

const initialState = (): AddressValidationState => {
  return {
    delivery: {
      valid: true,
      error: undefined
    },
    billing: {
      valid: true,
      error: undefined
    }
  }
}

const useAddressValidation = defineStore('addressValidation', {
  state: () => initialState(),
  actions: {
    async validateAddress(address: ShopAddress | undefined, addressType: AddressType) {
      return api
        .validateCheckoutAddress(addressType, address)
        .then(({ data }) => {
          this[addressType].valid = data.valid
          this[addressType].error = data.error

          if (data.valid && address) {
            this.localValidation(address, addressType)
          }
        })
        .catch(handleApiError)
    },
    localValidation(address: ShopAddress, addressType: AddressType) {
      const errors = getAddressFieldErrors(address)

      if (errors.length > 0) {
        this[addressType].valid = false
        this[addressType].error = errors.join(' ')
      }
    }
  }
})

export default useAddressValidation
